<div class="member-dashboard">
	<app-tabs
		class="tabs"
		[tabs]="TABS"
		[selectTab]="selectTab.asObservable()"
	></app-tabs>
	<router-outlet></router-outlet>
</div>
